import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/authContext';
<link href="https://fonts.googleapis.com/css2?family=Courgette&display=swap" rel="stylesheet"></link>

// Global error handler for unhandled promise rejections (Firebase permission errors)
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  const errorCode = error?.code;
  const errorMessage = error?.message || '';
  
  // Silently suppress Firebase permission errors
  if (
    errorCode === 'permission-denied' || 
    errorCode === 'firestore/permission-denied' ||
    errorMessage.includes('Missing or insufficient permissions') ||
    errorMessage.includes('permission-denied')
  ) {
    event.preventDefault(); // Prevent the error from showing in console/overlay
    console.warn('Suppressed permission error (non-fatal):', errorMessage);
    return;
  }
  
  // Let other errors through normally
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
